import moment from 'moment';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';

type UseSpaEntityFilterParams = {
  categoryId: number | null;
  arrivalDate: string | undefined;
  fromDate: string | undefined;
};

export function useSpaEntityFilter({
  categoryId,
  arrivalDate,
  fromDate,
}: UseSpaEntityFilterParams) {
  const router = useRouter();
  const today = moment().format();
  const initialDate = arrivalDate || fromDate || today;

  const [categoryFilterId, setCategoryFilterId] = useState<number | null>(categoryId);
  const [selectedCategory, setSelectedCategory] = useState<string | null>(
    categoryId ? String(categoryId) : null
  );
  const [appliedDate, setAppliedDate] = useState(initialDate);

  useEffect(() => {
    if (arrivalDate) {
      setAppliedDate(arrivalDate);
    }
  }, [arrivalDate]);

  const appliedDateString = appliedDate
    ? moment(appliedDate).format('YYYY-MM-DD')
    : moment().format('YYYY-MM-DD');

  const handleDirectCategoryChange = (value: string) => {
    const numericValue = !value || isNaN(Number(value)) ? null : Number(value);
    setCategoryFilterId(numericValue);
    setSelectedCategory(value || null);

    router.push(
      {
        pathname: router.pathname,
        query: { ...router.query, category: value || undefined },
      },
      undefined,
      { shallow: true }
    );
  };

  return {
    categoryFilterId,
    appliedDateString,
    selectedCategory,
    handleDirectCategoryChange,
  };
}
